import { Events } from 'backbone';

/**
 * Base event emitter class
 */
function EventEmitter() {}

EventEmitter.prototype = Events;

export default EventEmitter;
